


























































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "@/apollo";
import gql from "graphql-tag";
import ActorCard from "@/components/Cards/Actor.vue";
import LabelSelector from "@/components/LabelSelector.vue";
import actorFragment from "@/fragments/actor";
import { contextModule } from "@/store/context";
import InfiniteLoading from "vue-infinite-loading";
import IActor from "@/types/actor";
import ILabel from "@/types/label";
import DrawerMixin from "@/mixins/drawer";
import { mixins } from "vue-class-component";
import { actorModule } from "@/store/actor";
import CustomFieldFilter from "@/components/CustomFieldFilter.vue";
import countries from "@/util/countries";

@Component({
  components: {
    ActorCard,
    LabelSelector,
    InfiniteLoading,
    CustomFieldFilter,
  },
})
export default class ActorList extends mixins(DrawerMixin) {
  countryFilter = localStorage.getItem("pm_actorNationality") || null;

  get countries() {
    return countries;
  }

  get showSidenav() {
    return contextModule.showSidenav;
  }

  rerollSeed() {
    const seed = Math.random().toString(36);
    localStorage.setItem("pm_seed", seed);
    if (this.sortBy === "$shuffle") this.loadPage(this.page);
    return seed;
  }

  actors = [] as IActor[];

  fields = [] as any[];
  fetchLoader = false;
  fetchError = false;
  fetchingRandom = false;

  actorsBulkText = "" as string | null;
  bulkImportDialog = false;
  bulkLoader = false;

  get showCardLabels() {
    return contextModule.showCardLabels;
  }

  async runBulkImport() {
    this.bulkLoader = true;

    try {
      for (const name of this.actorsBulkImport) {
        await this.createActorWithName(name);
      }
      this.refreshPage();
      this.bulkImportDialog = false;
    } catch (error) {
      console.error(error);
    }

    this.actorsBulkText = "";
    this.bulkLoader = false;
  }

  get actorsBulkImport() {
    if (this.actorsBulkText) return this.actorsBulkText.split("\n").filter(Boolean);
    return [];
  }

  tryReadLabelsFromLocalStorage(key: string) {
    return (localStorage.getItem(key) || "").split(",").filter(Boolean) as string[];
  }

  allLabels = [] as ILabel[];
  selectedLabels = {
    include: this.tryReadLabelsFromLocalStorage("pm_actorInclude"),
    exclude: this.tryReadLabelsFromLocalStorage("pm_actorExclude"),
  };

  onSelectedLabelsChange(val: any) {
    localStorage.setItem("pm_actorInclude", val.include.join(","));
    localStorage.setItem("pm_actorExclude", val.exclude.join(","));
    this.refreshed = false;
  }

  validCreation = false;
  createActorDialog = false;
  createActorName = "";
  createActorAliases = [] as string[];
  createSelectedLabels = [] as number[];
  labelSelectorDialog = false;
  addActorLoader = false;

  actorNameRules = [(v) => (!!v && !!v.length) || "Invalid actor name"];

  query = localStorage.getItem("pm_actorQuery") || "";

  set page(page: number) {
    actorModule.setPage(page);
  }

  get page() {
    return actorModule.page;
  }

  get numResults() {
    return actorModule.numResults;
  }

  get numPages() {
    return actorModule.numPages;
  }

  sortDir = localStorage.getItem("pm_actorSortDir") || "desc";
  sortDirItems = [
    {
      text: "Ascending",
      value: "asc",
    },
    {
      text: "Descending",
      value: "desc",
    },
  ];

  sortBy = localStorage.getItem("pm_actorSortBy") || "relevance";
  sortByItems = [
    {
      text: "Relevance",
      value: "relevance",
    },
    {
      text: "A-Z",
      value: "name",
    },
    {
      text: "Added to collection",
      value: "addedOn",
    },
    {
      text: "Rating",
      value: "rating",
    },
    {
      text: "# scenes",
      value: "numScenes",
    },
    {
      text: "Views",
      value: "numViews",
    },
    {
      text: "Age",
      value: "age",
    },
    {
      text: "Bookmarked",
      value: "bookmark",
    },
    {
      text: "Random",
      value: "$shuffle",
    },
  ];

  favoritesOnly = localStorage.getItem("pm_actorFavorite") == "true";
  bookmarksOnly = localStorage.getItem("pm_actorBookmark") == "true";
  ratingFilter = parseInt(localStorage.getItem("pm_actorRating") || "0");

  createActorWithName(name: string) {
    return new Promise((resolve, reject) => {
      ApolloClient.mutate({
        mutation: gql`
          mutation($name: String!) {
            addActor(name: $name) {
              ...ActorFragment
              labels {
                _id
                name
              }
              thumbnail {
                _id
                color
              }
              numScenes
            }
          }
          ${actorFragment}
        `,
        variables: {
          name,
        },
      })
        .then((res) => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  addActor() {
    this.addActorLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($name: String!, $aliases: [String!], $labels: [String!]) {
          addActor(name: $name, aliases: $aliases, labels: $labels) {
            ...ActorFragment
            labels {
              _id
              name
            }
            thumbnail {
              _id
              color
            }
            numScenes
          }
        }
        ${actorFragment}
      `,
      variables: {
        name: this.createActorName,
        aliases: this.createActorAliases,
        labels: this.labelIDs(this.createSelectedLabels),
      },
    })
      .then((res) => {
        this.refreshPage();
        this.createActorDialog = false;
        this.createActorName = "";
        this.createActorAliases = [];
        this.createSelectedLabels = [];
      })
      .catch(() => {})
      .finally(() => {
        this.addActorLoader = false;
      });
  }

  openLabelSelectorDialog() {
    if (!this.allLabels.length) {
      ApolloClient.query({
        query: gql`
          {
            getLabels {
              _id
              name
              aliases
            }
          }
        `,
      })
        .then((res) => {
          this.allLabels = res.data.getLabels;
          this.labelSelectorDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.labelSelectorDialog = true;
    }
  }

  labelIDs(indices: number[]) {
    return indices.map((i) => this.allLabels[i]).map((l) => l._id);
  }

  labelNames(indices: number[]) {
    return indices.map((i) => this.allLabels[i].name);
  }

  openCreateDialog() {
    this.createActorDialog = true;
  }

  actorLabels(actor: any) {
    return actor.labels.map((l) => l.name);
  }

  actorActorNames(actor: any) {
    return actor.actors.map((a) => a.name).join(", ");
  }

  actorThumbnail(actor: any) {
    if (actor.thumbnail)
      return `${serverBase}/media/image/${actor.thumbnail._id}?password=${localStorage.getItem(
        "password"
      )}`;
    return "";
  }

  refreshed = true;

  resetPagination() {
    actorModule.resetPagination();
    this.refreshed = true;
    this.loadPage(this.page).catch(() => {
      this.refreshed = false;
    });
  }

  @Watch("ratingFilter", {})
  onRatingChange(newVal: number) {
    localStorage.setItem("pm_actorRating", newVal.toString());
    this.refreshed = false;
  }

  @Watch("favoritesOnly")
  onFavoriteChange(newVal: boolean) {
    localStorage.setItem("pm_actorFavorite", "" + newVal);
    this.refreshed = false;
  }

  @Watch("bookmarksOnly")
  onBookmarkChange(newVal: boolean) {
    localStorage.setItem("pm_actorBookmark", "" + newVal);
    this.refreshed = false;
  }

  @Watch("sortDir")
  onSortDirChange(newVal: string) {
    localStorage.setItem("pm_actorSortDir", newVal);
    this.refreshed = false;
  }

  @Watch("sortBy")
  onSortChange(newVal: string) {
    localStorage.setItem("pm_actorSortBy", newVal);
    this.refreshed = false;
  }

  @Watch("countryFilter")
  onNationalityChange() {
    if (this.countryFilter) {
      localStorage.setItem("pm_actorNationality", this.countryFilter);
    } else {
      localStorage.removeItem("pm_actorNationality");
    }
    this.refreshed = false;
  }

  @Watch("selectedLabels")
  onLabelChange() {
    this.refreshed = false;
  }

  @Watch("query")
  onQueryChange(newVal: string | null) {
    localStorage.setItem("pm_actorQuery", newVal || "");
    this.refreshed = false;
  }

  getRandom() {
    this.fetchingRandom = true;
    this.fetchPage(1, 1, true, Math.random().toString())
      .then((result) => {
        // @ts-ignore
        this.$router.push(`/actor/${result.items[0]._id}`);
      })
      .catch((err) => {
        this.fetchingRandom = false;
      });
  }

  async fetchPage(page: number, take = 24, random?: boolean, seed?: string) {
    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: ActorSearchQuery!, $seed: String) {
            getActors(query: $query, seed: $seed) {
              items {
                ...ActorFragment
                labels {
                  _id
                  name
                }
                thumbnail {
                  _id
                  color
                }
                altThumbnail {
                  _id
                }
                numScenes
              }
              numItems
              numPages
            }
          }
          ${actorFragment}
        `,
        variables: {
          query: {
            query: this.query || "",
            include: this.selectedLabels.include,
            exclude: this.selectedLabels.exclude,
            nationality: this.countryFilter || null,
            take,
            page: page - 1,
            sortDir: this.sortDir,
            sortBy: random ? "$shuffle" : this.sortBy,
            favorite: this.favoritesOnly,
            bookmark: this.bookmarksOnly,
            rating: this.ratingFilter,
          },
          seed: seed || localStorage.getItem("pm_seed") || "default",
        },
      });

      return result.data.getActors;
    } catch (err) {
      throw err;
    }
  }

  refreshPage() {
    this.loadPage(actorModule.page);
  }

  loadPage(page: number) {
    this.fetchLoader = true;

    return this.fetchPage(page)
      .then((result) => {
        this.fetchError = false;
        actorModule.setPagination({
          numResults: result.numItems,
          numPages: result.numPages,
        });
        this.actors = result.items;
      })
      .catch((err) => {
        console.error(err);
        this.fetchError = true;
      })
      .finally(() => {
        this.fetchLoader = false;
      });
  }

  mounted() {
    if (!this.actors.length) this.refreshPage();
  }

  beforeMount() {
    ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
            aliases
          }
          getCustomFields {
            _id
            name
            type
            values
            unit
            target
          }
        }
      `,
    })
      .then((res) => {
        this.fields = res.data.getCustomFields;
        this.allLabels = res.data.getLabels;
        if (!this.allLabels.length) {
          this.selectedLabels.include = [];
          this.selectedLabels.exclude = [];
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
